import { render, staticRenderFns } from "./estadistica.vue?vue&type=template&id=b481dabc&scoped=true"
import script from "./estadistica.vue?vue&type=script&lang=js"
export * from "./estadistica.vue?vue&type=script&lang=js"
import style0 from "./estadistica.vue?vue&type=style&index=0&id=b481dabc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b481dabc",
  null
  
)

export default component.exports